import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { FirestoreContext } from '../providers/firestore-provider'
import { IStoreState } from '../store/types'
import { Loading } from '../components'

export const PublicRoute = ({ component: Component, ...rest }: any) => {
  const { username } = useContext(FirestoreContext)
  const loading = useSelector((state: IStoreState) => state.ui.loading)

  return (
    <Route
      {...rest}
      exact
      component={(props) => {
        if (loading) return <Loading />
        if (username) return <Redirect to={'/home'} />

        return <Component {...props} />
      }}
    />
  )
}
